module.exports = "<div>\n  <ul>\n    <li>\n      <a [routerLink]=\"['home']\"> Home </a>\n    </li>\n  </ul>\n</div>\n"